import {configureStore} from '@reduxjs/toolkit';
import MenuSlice from './redux/menuSlice';
import CartSlice from './redux/cartSlice';

export const store = configureStore({
    reducer: {
        menu: MenuSlice,
        cart: CartSlice,
    },
});

export type RootState = ReturnType<typeof store.getState>;
